/**
 * Persona Types
 * AIDLC Administrative Backend
 *
 * Defines the persona system that controls navigation visibility.
 * Each persona maps to a real user role in the LDAJA organization:
 *
 *   executive   - CEO / Customer: budget approvals, high-level monitoring
 *   ops         - Operations Director (Dan): full admin, sees everything
 *   orchestrator - Scrum Master (Sam): planning, sprints, agent management
 *   builder     - Developer (Marcus etc): assigned work, sprint board
 *   gatekeeper  - Reviewer (Bill, Asha): review queue, DoD pipeline
 */

export const PERSONAS = ['executive', 'ops', 'orchestrator', 'builder', 'gatekeeper'] as const;

export type Persona = (typeof PERSONAS)[number];

export interface PersonaMeta {
  id: Persona;
  label: string;
  description: string;
  icon: string;
}

export const PERSONA_META: Record<Persona, PersonaMeta> = {
  executive: {
    id: 'executive',
    label: 'Executive',
    description: 'CEO / Customer view',
    icon: 'briefcase',
  },
  ops: {
    id: 'ops',
    label: 'Ops',
    description: 'Full admin access',
    icon: 'command',
  },
  orchestrator: {
    id: 'orchestrator',
    label: 'Orchestrator',
    description: 'Scrum Master view',
    icon: 'layers',
  },
  builder: {
    id: 'builder',
    label: 'Builder',
    description: 'Developer view',
    icon: 'code',
  },
  gatekeeper: {
    id: 'gatekeeper',
    label: 'Gatekeeper',
    description: 'Reviewer view',
    icon: 'check-shield',
  },
};

export const DEFAULT_PERSONA: Persona = 'ops';

export const PERSONA_STORAGE_KEY = 'aidlc-active-persona';
export const SIDEBAR_SECTIONS_STORAGE_KEY = 'aidlc-sidebar-sections';
